import { Link } from 'react-router-dom';
import Logo from '../../components/Logo';

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-surface">
      <nav className="border-b border-outline-variant/20 bg-surface/80 backdrop-blur-md sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="hover:opacity-80 transition-opacity">
            <Logo className="h-9 text-primary" />
          </Link>
          <Link to="/auth" className="text-xs font-bold uppercase tracking-widest text-primary hover:opacity-80 transition-opacity">Open Calculator</Link>
        </div>
      </nav>

      <main className="max-w-3xl mx-auto px-6 py-16">
        <p className="text-xs font-bold uppercase tracking-widest text-on-surface-variant mb-4">Legal</p>
        <h1 className="text-4xl font-headline font-bold text-primary mb-4">Privacy Policy</h1>
        <p className="text-sm text-on-surface-variant mb-12">Version 1.1 — Effective 13 April 2026</p>

        <div className="prose prose-sm max-w-none space-y-8 font-body text-on-surface">

          <section>
            <h2 className="text-xl font-headline font-bold text-primary mb-3">Who we are</h2>
            <p className="leading-relaxed text-on-surface-variant">
              Site Yield Pty Ltd (ABN to be confirmed) operates the Site Yield platform at siteyield.com.au. We are committed to protecting your personal information and handling it in accordance with the Australian Privacy Act 1988 (Cth) and the Australian Privacy Principles (APPs).
            </p>
          </section>

          <section>
            <h2 className="text-xl font-headline font-bold text-primary mb-3">What we collect</h2>
            <p className="leading-relaxed text-on-surface-variant mb-3">We may collect the following categories of information:</p>
            <ul className="list-disc pl-6 space-y-2 text-on-surface-variant">
              <li><strong>Account information:</strong> name, email address, and password (stored securely hashed).</li>
              <li><strong>Project inputs:</strong> site addresses, financial assumptions, and feasibility inputs you enter into the calculator.</li>
              <li><strong>Usage data:</strong> pages visited, features used, and session data for product improvement.</li>
              <li><strong>Authentication data:</strong> if you connect via Google OAuth, we receive your name and email from Google in accordance with Google's privacy policy.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-headline font-bold text-primary mb-3">How we use your information</h2>
            <ul className="list-disc pl-6 space-y-2 text-on-surface-variant">
              <li>To provide and maintain your account and access to the platform.</li>
              <li>To save and retrieve your scenario models and project inputs.</li>
              <li>To improve the platform and understand how users interact with it.</li>
              <li>To communicate service updates and legal changes.</li>
              <li>To comply with legal obligations.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-headline font-bold text-primary mb-3">Project data</h2>
            <p className="leading-relaxed text-on-surface-variant">
              Project inputs (including addresses and financial assumptions) you enter are stored in association with your account to support your sessions and scenario history. Your project data is <strong>private to your account by default</strong> and is not shared with other users or third parties for commercial purposes without your consent. We may use aggregated, de-identified data for analytics and product improvement.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-headline font-bold text-primary mb-3">Third-party services</h2>
            <p className="leading-relaxed text-on-surface-variant">
              We use third-party services to operate the platform, including cloud infrastructure, authentication (Google OAuth), and GIS data providers. These services have their own privacy policies. We do not sell your personal information to third parties.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-headline font-bold text-primary mb-3">Data retention</h2>
            <p className="leading-relaxed text-on-surface-variant">
              We retain account and project data for as long as your account is active or as required by law. You may request deletion of your account and associated data by contacting us at the address below.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-headline font-bold text-primary mb-3">Your rights</h2>
            <p className="leading-relaxed text-on-surface-variant">
              Under the Australian Privacy Act, you have the right to access personal information we hold about you, request corrections, and make a privacy complaint. To exercise these rights, contact us at <a href="mailto:carter.b.xu@gmail.com" className="text-primary underline">carter.b.xu@gmail.com</a>.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-headline font-bold text-primary mb-3">Contact</h2>
            <p className="leading-relaxed text-on-surface-variant">
              For privacy enquiries: <a href="mailto:carter.b.xu@gmail.com" className="text-primary underline">carter.b.xu@gmail.com</a>
            </p>
          </section>

        </div>
      </main>

      <footer className="border-t border-outline-variant/20 py-8 px-6">
        <div className="max-w-3xl mx-auto flex flex-wrap gap-4 text-xs text-on-surface-variant">
          <Link to="/legal/privacy-policy" className="hover:text-primary transition-colors font-bold text-primary">Privacy Policy</Link>
          <Link to="/legal/terms-of-use" className="hover:text-primary transition-colors">Terms of Use</Link>
          <Link to="/legal/cookie-notice" className="hover:text-primary transition-colors">Cookie Notice</Link>
          <Link to="/legal/output-disclaimer" className="hover:text-primary transition-colors">Output Disclaimer</Link>
        </div>
      </footer>
    </div>
  );
}
